// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "documentCard-yKx6E";
var _3 = "documentCard__icon-eXd9r";
var _4 = "documentCard__info-2qQMo";
var _5 = "documentCard__type-3-DXp";
var _6 = "documentCard__details-1WsQr";
var _7 = "documentCard__edit-1Tzg7";
var _8 = "documentCard__remove-1Fbqd";
export { _1 as "__esModule", _2 as "documentCard", _3 as "documentCard__icon", _4 as "documentCard__info", _5 as "documentCard__type", _6 as "documentCard__details", _7 as "documentCard__edit", _8 as "documentCard__remove" }
export default { "__esModule": _1, "documentCard": _2, "documentCard__icon": _3, "documentCard__info": _4, "documentCard__type": _5, "documentCard__details": _6, "documentCard__edit": _7, "documentCard__remove": _8 }
